(function () {
  function sync() {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      var n = parseInt((el.childNodes[0] && el.childNodes[0].textContent || '').trim(), 10);
      el.classList.toggle('swn-empty', !n);
    });
  }
  sync();
  new MutationObserver(sync).observe(document.body, { subtree: true, characterData: true, childList: true });
})();

/* SWN mystery welcome popup (2026-09-23). Two steps: capture email, THEN
   reveal the 10% code. Shows once (localStorage), 5s delay, homepage only. */
(function () {
  try {
    if (localStorage.getItem('swn_pop_done')) return;
  } catch (e) { return; }
  if (location.pathname !== '/' && !/^\/[a-z]{2}(-[A-Z]{2})?\/?$/.test(location.pathname)) return;
  function show() {
    var css = '#swn-pop-ov{position:fixed;inset:0;background:rgba(10,8,6,.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:18px}' +
      '#swn-pop{background:#fff;max-width:680px;width:100%;display:flex;overflow:hidden;box-shadow:0 30px 80px rgba(0,0,0,.35)}' +
      '#swn-pop .im{flex:0 0 42%;background-size:cover;background-position:top center;min-height:380px}' +
      '#swn-pop .ct{flex:1;padding:38px 34px;display:flex;flex-direction:column;justify-content:center;text-align:center;position:relative}' +
      '#swn-pop .x{position:absolute;top:10px;right:16px;font-size:26px;line-height:1;cursor:pointer;color:#999;background:none;border:none;padding:4px}' +
      '#swn-pop .eb{font-size:10px;letter-spacing:.3em;color:#8a8378;margin-bottom:12px}' +
      '#swn-pop h3{font-family:"Playfair Display",Georgia,serif;font-size:26px;font-weight:500;color:#141210;margin:0 0 10px}' +
      '#swn-pop p{font-size:13.5px;color:#6e675c;line-height:1.6;margin:0 0 18px}' +
      '#swn-pop input{width:100%;height:46px;border:1px solid #d9d9d9;padding:0 14px;font-size:14px;margin-bottom:10px;box-sizing:border-box}' +
      '#swn-pop button.go{width:100%;height:46px;background:#141210;color:#fff;border:0;font-size:11px;letter-spacing:.22em;text-transform:uppercase;cursor:pointer}' +
      '#swn-pop .code{font-family:"Playfair Display",Georgia,serif;font-size:30px;color:#141210;border:1px dashed #141210;padding:12px 10px;margin:6px 0 14px;user-select:all}' +
      '@media(max-width:600px){#swn-pop .im{display:none}}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    var ov = document.createElement('div'); ov.id = 'swn-pop-ov';
    ov.innerHTML = '<div id="swn-pop"><div class="im" style="background-image:url(https://cdn.shopify.com/s/files/1/1026/0142/5231/files/swn-hero-baddie-mobile.jpg?v=1790164504)"></div>' +
      '<div class="ct"><button class="x" aria-label="Close">&times;</button>' +
      '<div class="s1"><div class="eb">A WELCOME GIFT</div>' +
      '<h3>Your mystery discount awaits</h3>' +
      '<p>Enter your email and reveal the private welcome offer on your first watch.</p>' +
      '<input type="email" placeholder="Your email address" required>' +
      '<button class="go">Reveal my offer</button></div>' +
      '<div class="s2" style="display:none"><div class="eb">UNLOCKED</div>' +
      '<h3>10% off your first watch</h3>' +
      '<p>Use this code at checkout. It is yours, today.</p>' +
      '<div class="code">SWNWELCOME10</div>' +
      '<button class="go">Start shopping</button></div></div></div>';
    document.body.appendChild(ov);
    function done() { try { localStorage.setItem('swn_pop_done', '1'); } catch (e) {} ov.remove(); }
    ov.querySelector('.x').onclick = done;
    ov.addEventListener('click', function (e) { if (e.target === ov) done(); });
    ov.querySelector('.s1 .go').onclick = function () {
      var em = ov.querySelector('input').value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { ov.querySelector('input').style.borderColor = '#b00020'; return; }
      var fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '✓');
      fd.append('contact[email]', em); fd.append('contact[tags]', 'newsletter,popup-mystery');
      fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
      ov.querySelector('.s1').style.display = 'none';
      ov.querySelector('.s2').style.display = 'block';
      try { localStorage.setItem('swn_pop_done', '1'); } catch (e) {}
    };
    ov.querySelector('.s2 .go').onclick = done;
  }
  setTimeout(show, 5000);
})();

/* tablet hero portrait swap */
(function(){
  function fix(){
    try{
      var sec=document.getElementById('template--29470305616207__hero');
      if(!sec)return;
      var s=sec.querySelector('picture source[media*="767"]');
      if(!s)return;
      var first=(s.getAttribute('srcset')||'').split(',')[0].trim().split(' ')[0];
      if(!first)return;
      var base=first.replace(/([?&])width=\d+&?/,'$1').replace(/[?&]$/,'');
      var sep=base.indexOf('?')>-1?'&':'?';
      s.setAttribute('srcset',base+sep+'width=1400 1400w, '+base+sep+'width=1000 1000w, '+base+sep+'width=680 680w');
      s.setAttribute('sizes','100vw');
      s.setAttribute('media','(max-width: 1149px)');
    }catch(e){}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fix);}else{fix();}
})();

/* uk tag geo block */
(function(){
  if(!window.__swnTagPage)return;
  try{
    var c=sessionStorage.swn_geo;
    if(c==='GB'){location.replace('/');return;}
    if(!c){
      fetch('/browsing_context_suggestions.json').then(function(r){return r.json();}).then(function(d){
        var cc=(((d||{}).detected_values||{}).country||{}).handle||'XX';
        sessionStorage.swn_geo=cc;
        if(cc==='GB'){location.replace('/');}
      }).catch(function(){});
    }
  }catch(e){}
})();

/* SWN-LOT-BANNER START */
/* Today's deal on the PDP, v3 (2026-10-22, owner: "more encouraging and fomo").
   Urgency is REAL: discounts genuinely expire at 00:00 UTC, so the countdown
   targets next UTC midnight. No fabricated scarcity. Values stored in GBP;
   converted to the active presentment currency via Shopify.currency.rate. */
(function () {
  var d = window.SWN_DEAL_TODAY;
  if (!d || !d.deal || !d.usual) return;
  if (Number(d.deal) >= Number(d.usual)) return;   /* never advertise a non-saving */

  function ccy() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'; }
    catch (e) { return 'GBP'; }
  }
  function rate() {
    try {
      var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
      return (r && r > 0) ? r : 1;
    } catch (e) { return 1; }
  }
  function money(n) {
    var v = Number(n) * rate();
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
        { style: 'currency', currency: ccy() }).format(v);
    } catch (e) {
      return ccy() + ' ' + v.toFixed(2);
    }
  }
  function endUtcMidnight() {
    var now = new Date();
    return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 0, 0, 0);
  }
  function pad(v) { return ('0' + v).slice(-2); }

  function boot() {
    if (document.getElementById('swn-lot')) return;
    var sel = ['.product-detail__price', '[id^="price-template--"]',
               '.card-product-price.price-large'];
    var anchor = null;
    for (var i = 0; i < sel.length && !anchor; i++) anchor = document.querySelector(sel[i]);
    if (!anchor || !anchor.parentNode) return;

    /* v4 (owner 2026-10-23): never compute the save chip against the sale
       price - use the struck compare-at (rrp) when the metafield carries it. */
    var base = (d.rrp && Number(d.rrp) > Number(d.usual)) ? Number(d.rrp) : Number(d.usual);
    var save = base - Number(d.deal);
    var pct = Math.round(100 * save / base);

    var css = ''
      + '#swn-lot{position:relative;border:1px solid #d9b980;border-radius:6px;'
      + 'padding:13px 15px 12px;margin:14px 0;font-family:Arial,sans-serif;'
      + 'background:linear-gradient(135deg,#fffdf8 0%,#fbf4e4 100%);'
      + 'box-shadow:0 1px 10px rgba(143,110,60,.10);overflow:hidden}'
      + '#swn-lot:before{content:"";position:absolute;left:0;top:0;bottom:0;width:3px;'
      + 'background:linear-gradient(180deg,#c9a24b,#8F6E3C)}'
      + '#swn-lot .top{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:7px}'
      + '#swn-lot .badge{display:inline-flex;align-items:center;gap:6px;background:#141210;'
      + 'color:#f3e8cf;font-size:10.5px;font-weight:700;letter-spacing:.18em;'
      + 'text-transform:uppercase;padding:4px 10px;border-radius:3px}'
      + '#swn-lot .badge i{width:6px;height:6px;border-radius:50%;background:#e0b25c;'
      + 'animation:swnlotpulse 1.4s ease-in-out infinite}'
      + '@keyframes swnlotpulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.35;transform:scale(.7)}}'
      + '#swn-lot .chip{font-size:11.5px;font-weight:700;color:#8a2f20;background:#f9e3dc;'
      + 'padding:4px 9px;border-radius:3px;letter-spacing:.02em}'
      + '#swn-lot .pr{font-family:"Playfair Display",Georgia,serif;font-size:26px;'
      + 'color:#141210;line-height:1.1}'
      + '#swn-lot .was{text-decoration:line-through;color:#9a917f;font-size:14.5px;margin-left:9px;'
      + 'font-family:Arial,sans-serif}'
      + '#swn-lot .cd{display:flex;align-items:center;gap:7px;margin-top:8px;'
      + 'font-size:12.5px;color:#4a4238}'
      + '#swn-lot .cd b{font-variant-numeric:tabular-nums;font-size:14.5px;color:#141210;'
      + 'letter-spacing:.04em}'
      + '#swn-lot .cd svg{flex:0 0 auto}'
      + '#swn-lot .nb{font-size:11.5px;color:#7a736a;margin-top:5px;line-height:1.5}'
      + '@media(max-width:768px){#swn-lot{padding:11px 12px}#swn-lot .pr{font-size:23px}}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

    var el = document.createElement('div'); el.id = 'swn-lot';
    el.innerHTML = ''
      + '<div class="top"><span class="badge"><i></i>Today Only</span>'
      + '<span class="chip">Save ' + money(save) + ' (' + pct + '%)</span></div>'
      + '<div class="pr">' + money(d.deal) + '<span class="was">' + money(d.usual) + '</span></div>'
      + '<div class="cd"><svg width="13" height="13" viewBox="0 0 24 24" fill="none">'
      + '<circle cx="12" cy="12" r="9" stroke="#8F6E3C" stroke-width="2"/>'
      + '<path d="M12 7v5l3.5 2" stroke="#8F6E3C" stroke-width="2" stroke-linecap="round"/></svg>'
      + 'Deal ends in <b id="swn-lot-cd">--:--:--</b></div>'
      + '<div class="nb">Deal price is applied automatically at checkout. '
      + 'Tomorrow it returns to ' + money(d.usual) + '.</div>';
    anchor.parentNode.insertBefore(el, anchor.nextSibling);

    /* only ONE save figure on the page: hide the theme's standalone
       "SAVE n%" badge while the deal banner is up */
    try {
      var walker = document.querySelectorAll('span,div,p,strong,b');
      for (var w = 0; w < walker.length; w++) {
        var tx = (walker[w].textContent || '').trim();
        if (tx.length <= 10 && /^save\s+\d+%$/i.test(tx) && !el.contains(walker[w])) {
          walker[w].style.display = 'none';
        }
      }
    } catch (e) {}

    var end = endUtcMidnight();
    function tick() {
      var tcd = document.getElementById('swn-lot-cd');
      if (!tcd) return;
      var ms = end - Date.now();
      if (ms <= 0) { var lot = document.getElementById('swn-lot'); if (lot) lot.style.display = 'none'; return; }
      var s = Math.floor(ms / 1000);
      var hh = Math.floor(s / 3600); s %= 3600;
      var mm = Math.floor(s / 60); s %= 60;
      tcd.textContent = pad(hh) + ':' + pad(mm) + ':' + pad(s);
      setTimeout(tick, 1000);
    }
    tick();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  [300, 900, 2000, 3500].forEach(function (ms) { setTimeout(boot, ms); });
})();
/* SWN-LOT-BANNER END */
